<script>
  import theme from "./../stores/theme";
  import { onMount } from "svelte";
  import app from "../stores/app";

  $: bg = $theme.mode == "dark" ? "bg-gray-800" : "bg-brand-white";
  $: text = $theme.mode == "dark" ? "text-gray-500" : "text-gray-700";
  $: bgImage = $theme.mode == "dark" ? "light.svg" : "dark.svg";

  onMount(() => {
    if ($theme.mode == "dark") {
      document.body.style.backgroundColor = "#2d3748";
    } else {
      document.body.style.backgroundColor = "#fcfcfc";
    }
  });
</script>

<div
  class={`${bg} ${text} text-base min-h-screen`}
  id="home"
  style={`background-image: url(./images/circuit-${bgImage});`}
>
  <slot />
</div>
